import { useTranslation } from 'react-i18next';

export default function ExclusiveQuote() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-950 py-10 md:py-14 px-4 md:px-8 lg:px-12">
      <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        <div className="flex-1 lg:flex-[3]">
          <div className="flex items-center gap-2 mb-6">
            <span className="w-2 h-2 rounded-full bg-primary-500" />
            <span className="text-sm text-foreground-200">{t('exclusiveLabel')}</span>
          </div>
          <blockquote className="text-xl md:text-2xl lg:text-3xl font-serif text-foreground-50 leading-relaxed mb-6">
            <span className="text-primary-500 text-3xl md:text-4xl">&ldquo;</span>
            {t('exclusiveQuote')}
          </blockquote>
          <div className="flex items-center gap-3">
            <span className="text-sm font-semibold text-foreground-200">{t('exclusiveAuthor')}</span>
            <span className="w-4 h-4 flex items-center justify-center rounded-full bg-green-500 text-white text-[10px]">
              <i className="ri-check-line" />
            </span>
            <span className="text-xs text-foreground-300">官方认证</span>
          </div>
        </div>

        <div className="lg:flex-[2] w-full max-w-sm lg:max-w-none">
          <div className="relative w-full h-[400px] md:h-[500px] overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20studio%20portrait%20of%20confident%20person%20in%20elegant%20dark%20attire%20with%20side%20profile%20looking%20upward%20against%20clean%20white%20background%2C%20high%20fashion%20editorial%20photography%20with%20dramatic%20lighting%20and%20soft%20shadows%2C%20sophisticated%20and%20mysterious%20expression%20with%20professional%20composition&width=600&height=800&seq=exclusive-portrait&orientation=portrait"
              alt="独家首发编辑"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}